import Link from 'next/link';
import { ReactNode } from 'react';

export const faqs: { question: string; answer: ReactNode }[] = [
  {
    question: 'How do so many people win?',
    answer: (
      <>
        We have many more winners in smaller prize categories than big ones; but
        there's nothing more exciting for us than making someone's day with a
        bucket list trip!
      </>
    ),
  },
  {
    question: 'What are my odds of winning?',
    answer: (
      <>
        On average, every entry has roughly a 1 in 3 chance of winning something
        (from tokens worth 50p to trips worth £100k) in each and every draw. We
        do things differently from the major lotteries and prize draws out
        there, swapping those huge but "never-going-to-happen" jackpots for much
        better odds of winning prizes big & small.
      </>
    ),
  },
  {
    question: 'How does it work?',
    answer: (
      <>
        <p>
          You pick your numbers for each weekly draw. We draw numbers at random
          (you can watch the live draw on Instagram) and the more numbers you
          match, the bigger the prize tier you can choose from.
        </p>
        <p>Our memberships mean you have full control, but never miss out.</p>
      </>
    ),
  },
  {
    question: 'Where do my trees get planted?',
    answer: (
      <>
        We work with{' '}
        <Link
          href="https://www.veritree.com/why-veritree/measurable-impact"
          target="_blank"
          rel="noopener noreferrer"
        >
          veritree
        </Link>{' '}
        who plant verifiable trees donated by DAYMADE players in Kenya, Tanzania
        and Senegal.
      </>
    ),
  },
  {
    question: 'Can I customise my trip and bring a guest?',
    answer: (
      <>
        <p>
          Of course! For most trips, we'll put you in touch with a travel
          partner to arrange the finer details of the trip.
        </p>
        <p>
          You can depart from any major UK airport and (unless specified
          otherwise) you can bring guests with you. For the highest prize tiers,
          you could even bring your whole family!
        </p>
      </>
    ),
  },
  {
    question: 'How do I know this is not a scam?',
    answer: (
      <>
        <p>
          We understand that you might be nervous. Here are five ways you can
          prove for yourself that DAYMADE is a legitimate company who create
          real winners every single week.
        </p>
        <ul
          style={{
            margin: 'var(--dm2025-paragraphSpacing) 0 0 0',
            paddingLeft: '1.25rem',
          }}
        >
          <li>
            Google DAYMADE and check out our TrustPilot (4.6-stars) and Google
            Reviews (4.9-stars).
          </li>
          <li>
            Head to instagram.com/daymadeuk where you can see stories from our
            winners every week.
          </li>
          <li>
            Visit daymade.co.uk/about-us where you can meet the small, UK based,
            team behind DAYMADE.
          </li>
          <li>
            Search for Zeal Network - the largest Lottery Company in Germany -
            who are DAYMADE's backers.
          </li>
          <li>
            Head to Companies House and search for DAYMADE Ltd. where you can
            find all the public information about our company.
          </li>
        </ul>
      </>
    ),
  },
];
